import googleAnalyticsMiddleware from 'store/middleware/googleAnaltyicsMiddleware';

export default [
    googleAnalyticsMiddleware,
];



// WEBPACK FOOTER //
// ./src/store/middleware/customResourceMiddleware.js